
import IndustryGroup from "./industry-group";

const ModuleName = "tfApp.instruments";

export default angular.module(ModuleName, [IndustryGroup(ModuleName)])
                      .name;